import { AxiosInstance, isAxiosError } from "axios";
import { Leitura } from "./leitura";
import { TipoLeitura } from "./tipo-leitura";

type AddLeituraRequest = {
    record: Omit<Leitura, 'consumo'>
    codigo_condominio: number
}

type ListLeiturasRequest = {
    codigo_condominio: number
    tipo: TipoLeitura
    ano: number
    mes: number
}

type SendNotificationRequest = {
    codigo_condominio: number
    tipo: TipoLeitura
    ano: number
    mes: number
    records: Omit<Leitura, 'consumo'>[]
}

export class LeituraRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async add({ record, codigo_condominio }: AddLeituraRequest): Promise<Leitura> {
        try {
            let url = `condominios/${codigo_condominio}/leituras/${record.tipo}/${record.ano}/${record.mes}`;
            let { data } = await this.api.post<Leitura>(url, record)
            return data
        } catch (error: any) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error || "Não foi possível adicionar a leitura")
            }
            if (error instanceof Error) {
                throw new Error(error.message || "Não foi possível adicionar a leitura")
            }
            throw new Error("Não foi possível adicionar a leitura")
        }
    }

    async list({ codigo_condominio, tipo, ano, mes }: ListLeiturasRequest): Promise<Leitura[]> {
        try {
            let url = `condominios/${codigo_condominio}/leituras/${tipo}/${ano}/${mes}`;
            let { data } = await this.api.get<Leitura[]>(url)
            return data
        } catch (error: any) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error || "Não foi possível carregar as leitura")
            }
            if (error instanceof Error) {
                throw new Error(error.message || "Não foi possível carregar as leitura")
            }
            throw new Error("Não foi possível carregar as leitura")
        }
    }

    async sendNotification({ codigo_condominio, tipo, ano, mes, records }: SendNotificationRequest): Promise<void> {
        try {
            let url = `condominios/${codigo_condominio}/leituras/${tipo}/${ano}/${mes}/send-notifications`;
            await this.api.post<void>(url, {
                leituras: records
            })
        } catch (error: any) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error || "Não foi possível adicionar a leitura")
            }
            if (error instanceof Error) {
                throw new Error(error.message || "Não foi possível adicionar a leitura")
            }
            throw new Error("Não foi possível adicionar a leitura")
        }
    }
}